import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { getToken, getUsername, getEmail, removeToken } from '../../../services/LocalStorageService';
import { useChangePasswordMutation } from '../../../services/dvagent';
import { Toaster } from '../../@dashboard/attributes'
import Iconify from '../../../components/iconify';

export default function ChangePassword() {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [oldPasswordError, setOldPasswordError] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [showOldPassword, setshowOldPassword] = useState(false);
  const [showNewPassword, setshowNewPassword] = useState(false);
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);

  const [changePassword] = useChangePasswordMutation();
  const navigate = useNavigate();
  const passwordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{9,}$/;

  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const handleOldPassword = (event) => {
    setOldPassword(event.target.value);
    setOldPasswordError('');
  }
  const handleNewPassword = (event) => {
    setNewPassword(event.target.value);
    setNewPasswordError('');
  }
  const handleConfirmPassword = (event) => {
    setConfirmPassword(event.target.value);
    setConfirmPasswordError('');
  }


  const handleChangePassword = async () => {
    if (!oldPassword) {
        setOldPasswordError('Please enter old password');
    } else {
        setOldPasswordError('');
    }

    if (!newPassword) {
        setNewPasswordError('Please enter new password');
    } else if (newPassword <= 8) {
        setNewPasswordError('Password length must be greater than 8 characters');
    } else if (!passwordPattern.test(newPassword)) {
        setNewPasswordError('Please follow the password instructions');
    } else if (oldPassword === newPassword) {
        setNewPasswordError('Old password same as new password');
    } else {
        setNewPasswordError('');
    }

    if (!confirmPassword) {
        setConfirmPasswordError('Please enter confirm password');
    } else if (confirmPassword <= 8) {
        setConfirmPasswordError('Password length must be greater than 8 characters')
    } else if (newPassword !== confirmPassword) {
        setConfirmPasswordError('New password and Confirmation password not match');
    } else {
        setConfirmPasswordError('');
    }

    if (!oldPassword || !newPassword || !confirmPassword || newPassword !== confirmPassword || newPassword <= 8 || confirmPassword <= 8 || !passwordPattern.test(newPassword) || oldPassword === newPassword) {
      return;
    }

    const actualData = {
      data: {
        "old_password":oldPassword,
        "new_password":newPassword
      },
      token: getToken()
    }
    const res = await changePassword(actualData);
    if (res.error) {
      if (res.error.status===400) {
        showToast(false, 'ⓘ', 'Old password is incorrect');
      } else if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    if (res.data) {
      showToast(true, '✔', 'Password changed, Please login again with your new password');
      setTimeout(() => {
        removeToken()
        navigate('/');
      }, 5000);
    }
  }

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Box 
        alignItems="center"
        justifyContent="center"
        mx="auto"
        mt={-8}
        >
        <Avatar
            src="../user/default-user.gif"
            sx={{ width: 100, height: 100, margin: "auto", 
            borderColor: '#A8A196' }}
        />
        <CardContent>
          <Typography gutterBottom variant="" component="div" sx={{ mx: "auto", textAlign:"center", paddingTop:1, fontSize: 16, fontWeight: 'bold'}}>
            {getUsername()}
          </Typography>
          <Typography gutterBottom variant="body2" color="text.secondary" component="div" sx={{mx: "auto", textAlign:"center", fontSize: 15 }}>
            {getEmail()}
          </Typography>
        </CardContent>
      </Box>
      <Stack spacing={3}>
        <TextField
            label="Old Password"
            variant="outlined"
            type={showOldPassword ? 'text' : 'password'}
            defaultValue={oldPassword}
            onChange={(handleOldPassword)}
            helperText={oldPasswordError}
            error={Boolean(oldPasswordError)}
            InputProps={{
                endAdornment: (
                <InputAdornment position="end">
                    <IconButton onClick={() => setshowOldPassword(!showOldPassword)} edge="end">
                    <Iconify icon={showOldPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                </InputAdornment>
                ),
            }}
        />
        <TextField
            label="New Password"
            variant="outlined"
            type={showNewPassword ? 'text' : 'password'}
            defaultValue={newPassword}
            onChange={handleNewPassword}
            helperText={newPasswordError}
            error={Boolean(newPasswordError)}
            InputProps={{
                endAdornment: (
                <InputAdornment position="end">
                    <IconButton onClick={() => setshowNewPassword(!showNewPassword)} edge="end">
                    <Iconify icon={showNewPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                </InputAdornment>
                ),
            }}
        />
        <TextField
            label="Confirm Password"
            variant="outlined"
            type={showConfirmPassword ? 'text' : 'password'}
            defaultValue={confirmPassword}
            onChange={handleConfirmPassword}
            helperText={confirmPasswordError}
            error={Boolean(confirmPasswordError)}
            InputProps={{
                endAdornment: (
                <InputAdornment position="end">
                    <IconButton onClick={() => setshowConfirmPassword(!showConfirmPassword)} edge="end">
                    <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                </InputAdornment>
                ),
            }}
        />
        <Button
          onClick={() => handleChangePassword()}
          sx={{
            color: '#FFF',
            border: 1,
            borderColor: '#A8A196',
            bgcolor: '#A8A196',
            ":hover": {
                bgcolor: "#7D7463",
                borderColor: '#7D7463',
            }
          }}>
          Change Password
        </Button>
      </Stack>
    </>
  );
}